import React, { useEffect, useState } from 'react';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import AgileUploadRow from '@components/agile/types/AgileUploadRow';
import { ICellRendererParams } from 'ag-grid-community';
import { AgileMacroplanogram, storeSubcategory } from '@components/agile/types/AgileMacroplanogramTypes';
import Icon from '@amzn/meridian/icon';
import { ERROR_COLOR } from '@constants/values';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Tooltip from '@amzn/meridian/tooltip';
import { AssortmentEntryAction } from '@graphql/generated/graphql';

const AtDiffSubCategoriesCellRenderer = (params: {
  node: ICellRendererParams;
  setRowData: (value: AgileUploadRow[]) => void;
  rowData: AgileUploadRow[];
  setRecommendationFlag: (value: boolean) => void;
  listOfMacroplanogram: AgileMacroplanogram[] | undefined;
  value: string;
}) => {
  const { node, setRowData, rowData, listOfMacroplanogram } = params;
  const data = node.data as AgileUploadRow;
  const [selectedCategory, setSelectedCategory] = useState<string>(data.subcategoryId as string);
  const [subCategoryList, setSubCategoryList] = useState<storeSubcategory[]>();
  const [errorFlag, setErrorFlag] = useState(!selectedCategory);
  const onClick = (subCategoryId: string) => {
    setSelectedCategory(subCategoryId);
    const tempData = [...rowData];
    const rowIndex = tempData.findIndex((item) => item.index === data.index);
    tempData[rowIndex].subcategoryId = subCategoryId;
    setRowData(tempData);
    setErrorFlag(false);
  };

  useEffect(() => {
    const subCategories = !listOfMacroplanogram
      ? []
      : (listOfMacroplanogram.find((macroplanogram) => macroplanogram.entryId === data.macroplanogramId)
          ?.storeSubcategories ?? []);
    setSubCategoryList(subCategories);
  }, [listOfMacroplanogram, data.macroplanogramId]);

  return (
    <Row spacing="none" spacingInset="none" maxWidth="50">
      {data.action?.action === AssortmentEntryAction.Remove ? (
        <span>
          {' '}
          {
            subCategoryList?.find((macroPlanogram) => macroPlanogram.subcategoryId === selectedCategory)
              ?.subcategoryName
          }
        </span>
      ) : (
        <Select value={selectedCategory} onChange={onClick} width={130} error={errorFlag}>
          {subCategoryList?.map((subCategory) => (
            <SelectOption
              value={subCategory.subcategoryId}
              label={subCategory.subcategoryName}
              key={subCategory.subcategoryId}
            />
          ))}
        </Select>
      )}
      {errorFlag ? (
        <Tooltip position="end" title="Please select a subcategory" id="myTooltip">
          <Icon className={ERROR_COLOR} tokens={infoKnockoutTokens} />
        </Tooltip>
      ) : null}
    </Row>
  );
};

export default AtDiffSubCategoriesCellRenderer;
